import httpClient from "@/api/httpClient";
import {
  IPurchaseResponse,
  IPurchase,
  IAddPurchaseRequest,
} from "./purchase.interface";

export const getPurchasesService = async (
  page: number = 0,
  limit: number = 10,
  sort: string = "",
  order: "asc" | "desc",
  search: string = ""
): Promise<IPurchaseResponse> => {
  try {
    const params: any = {
      page,
      limit,
    };

    if (sort) {
      params.sort = sort;
    }
    if (order) {
      params.order = order;
    }
    if (search) {
      params.search = search;
    }

    const response = await httpClient.get("/v1/history/purchase-orders", {
      params,
    });

    return response.data;
  } catch (e) {
    throw e;
  }
};

export const getPurchaseService = async (id: string): Promise<IPurchase> => {
  try {
    const response = await httpClient.get(`/v1/history/purchase-orders/${id}`);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const updatePurchaseService = async (
  id: string,
  purchase: IPurchase
): Promise<IPurchase> => {
  try {
    const response = await httpClient.patch(
      `/v1/history/purchase-orders/${id}`,
      purchase
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const deletePurchaseService = async (id: string): Promise<IPurchase> => {
  try {
    const response = await httpClient.delete(
      `/v1/history/purchase-orders/${id}`
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const addPurchaseService = async (
  purchase: IAddPurchaseRequest
): Promise<IPurchase> => {
  try {
    const response = await httpClient.post("/v1/purchase", purchase);
    return response.data;
  } catch (e) {
    throw e;
  }
};
